// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basket-mobile{padding-left:16px;padding-right:16px;max-width:540px;min-width:320px;width:100%;margin-left:auto;margin-right:auto;padding:12px 0 40px}.basket-mobile._stub{min-height:200px}.basket-mobile__content-holder{padding-left:16px;padding-right:16px}.basket-mobile__delivery-info{margin-top:8px}", ""]);
// Exports
module.exports = exports;
